/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FacilityStatusType {
  Active = 'Active',
  Inactive = 'Inactive'
}
